import * as server from '../entries/pages/(admin)/admin/_layout.server.ts.js';

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(admin)/admin/_layout.svelte.js')).default;
export { server };
export const server_id = "src/routes/(admin)/admin/+layout.server.ts";
export const imports = ["_app/immutable/nodes/2.3pBRVf_E.js","_app/immutable/chunks/CslV50be.js","_app/immutable/chunks/C3H89rdt.js","_app/immutable/chunks/DM11LlHJ.js","_app/immutable/chunks/CuhEQ3BH.js","_app/immutable/chunks/BQugib7O.js","_app/immutable/chunks/BTxgzX-9.js","_app/immutable/chunks/pTubWVUb.js","_app/immutable/chunks/BN8CHBz-.js","_app/immutable/chunks/DJU9tcyv.js","_app/immutable/chunks/B5iMIKFo.js","_app/immutable/chunks/CWir8Kn7.js"];
export const stylesheets = ["_app/immutable/assets/2.Cz_lkjv4.css"];
export const fonts = [];
